<template>
	<page style="background: #fff;">
		<c-title>盘点扫码记录</c-title>
		<div>
			<detail-card v-for="(item, i) in productList" :key="i" :index="i + 1">
				<template #title>
					<span class="product-title flex-start-center">
						<c-state v-if="item.level_type" dict="LEVEL_TYPE" :value="item.level_type" type="hollow"></c-state>
						<span>{{[item.brand_name, item.spu_model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span>
					</span>
				</template>

				<template #default>
					<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
					<c-field label="IMEI">{{item.produce_imei || '-'}}</c-field>
					<c-field label="接驳人">{{item.recipient_user_realname || '-'}}</c-field>
				</template>
			</detail-card>
		</div>

		<c-title>盘点完成</c-title>
		<div class="loss-total flex-start-center">
			<p>盘点总数：<span>{{productList.length}}</span></p>
			<p>盘亏背贴码：<b>{{profitLossList.length}}条</b></p>
			<p>盘盈背贴码：<b class="profit-count">{{profitList.length}}条</b></p>
		</div>
		<div class="list-title">盘亏明细</div>
		<div>
			<div v-for="(item, i) in profitLossList" :key="i" class="loss-item">
				<p>{{item.produce_unique_code}}</p>
				<p><span>{{[item.brand_name, item.spu_model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span></p>
				<p v-if="item.lend_state == 1 || item.lend_state == 0">
					<span v-if="item.lend_state == 1" class="lend-mark">借出：{{item.lend_borrower_name || '-'}}</span>
					<span v-else>未借出</span>
				</p>
			</div>
			<c-empty v-if="!profitLossList.length" message="无盘亏"></c-empty>
		</div>

		<div class="list-title">盘盈明细</div>
		<div>
			<div v-for="(item, i) in profitList" :key="'profit-' + i" class="loss-item profit-item">
				<p>{{item.produce_unique_code}}</p>
				<p><span>{{[item.brand_name, item.spu_model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span></p>
				<p v-if="item.remark"><span class="profit-remark">{{item.remark}}</span></p>
			</div>
			<c-empty v-if="!profitList.length" message="无盘盈"></c-empty>
		</div>

		<template v-if="remark">
			<c-title>备注</c-title>
			<div class="loss-remark">{{remark}}</div>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			id: [String, Number]
		},

		data() {
			return {
				productList: [],
				profitLossList: [],
				profitList: [],
				remark: ''
			}
		},

		mounted() {
			this.request({
				url: '/inventory/detail',
				data: {
					id: this.id
				},
				success: data => {
					this.productList = data.product_list || [];
					this.profitLossList = data.profit_loss_list || [];
					this.profitList = data.profit_list || [];
					this.remark = data.remark;
				}
			})
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .c-title {
		margin: .2rem .3rem 0;
	}

	>>> .c-card {
		margin: 0 .3rem;
	}

	.loss {
		&-total {
			gap: .16rem .3rem;
			flex-wrap: wrap;
			min-height: .64rem;
			padding: .08rem .3rem;
			font-size: .26rem;
			color: #666;

			span {
				color: #3D5EFF;
			}

			b {
				color: #f00;
			}
		}

		&-item {
			border-radius: .08rem;
			padding: .14rem .26rem;
			margin: 0 .24rem;
			line-height: .38rem;
			font-size: .28rem;
			color: #f55;
			background: #FFF5F5;

			&:nth-child(n+2) {
				margin-top: .16rem;
			}

			span {
				font-size: .24rem;
				color: #666;
			}
		}

		&-remark {
			border-radius: .08rem;
			padding: .2rem .3rem;
			margin: 0 .3rem;
			line-height: .4rem;
			font-size: .26rem;
			word-break: break-word;
			background: #F9F9F9;
		}
	}

	.product-title {
		gap: .1rem;
		flex-wrap: wrap;
	}

	.list-title {
		margin: .24rem .3rem .12rem;
		font-size: .28rem;
		font-weight: 600;
		color: #666;
	}

	.loss-total b.profit-count {
		color: #1890ff;
	}

	.loss-item.profit-item {
		color: #1890ff;
		background: #E6F7FF;
	}

	.loss-item .profit-remark {
		color: #1890ff;
	}

	.loss-item .lend-mark,
	.lend-mark {
		color: #ff6900;
	}
</style>